import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { TeacherEvaluationCriteriaType, TeacherEvaluationReportType, TeacherEvaluationType } from "../../../types/TeacherEvaluation";
import { get, post, put } from "../../../utils/axios-config";
import { TEACHER_EVALUATION_CRITERIAS, TEACHER_EVALUATIONS, TEACHER_EVALUATIONS_CRITERIAS, TEACHER_EVALUATIONS_CRITERIAS_REPORT } from "../../../utils/constants";


export const createTeacherEvaluationCriteria= async (data: TeacherEvaluationCriteriaType) => await post<TeacherEvaluationCriteriaType, string>(TEACHER_EVALUATION_CRITERIAS, data);
export const updateTeacherEvaluationCriteria= async (data: TeacherEvaluationCriteriaType) => await put<TeacherEvaluationCriteriaType, string>(TEACHER_EVALUATION_CRITERIAS, data);
export const getTeacherEvaluationCriterias  = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
    });
    if(data?.IsForStudent){
        queryParams.append("IsForStudent", String(data?.IsForStudent))
    }
    const url = `${TEACHER_EVALUATION_CRITERIAS}?${queryParams.toString()}`;
    return await get<PagedResultsType<TeacherEvaluationCriteriaType>>(url)
};


export const createTeacherEvaluation= async (data: TeacherEvaluationType) => await post<TeacherEvaluationType, string>(TEACHER_EVALUATIONS, data);
export const getTeacherEvaluation  = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
    });
    if(data?.IsForStudent){
        queryParams.append("IsForStudent", String(data?.IsForStudent))
    }
    const url = `${TEACHER_EVALUATIONS}?${queryParams.toString()}`;
    return await get<PagedResultsType<TeacherEvaluationType>>(url)
};
export const createTeachersEvaluationsCriterias= async (data: any) => await post<any, string>(TEACHER_EVALUATIONS_CRITERIAS, data);
export const getTeachersEvaluationsCriterias = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
        ...(data?.IdTeacherEvaluation ? { IdTeacherEvaluation: data.IdTeacherEvaluation } : {}),
    });
    if(data?.IsForStudent){
        queryParams.append("IsForStudent", String(data?.IsForStudent))
    }
    const url = `${TEACHER_EVALUATIONS_CRITERIAS}?${queryParams.toString()}`;
    return await get<PagedResultsType<TeacherEvaluationType>>(url)
};

export const getTeachersEvaluationsCriteriasReport = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        // PageNumber: data?.PageNumber?.toString() || '1',
        // PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
        ...(data?.IdTeacherEvaluation ? { IdTeacherEvaluation: data.IdTeacherEvaluation } : {}),
    });
    if(data?.IsForStudent){
        queryParams.append("IsForStudent", String(data?.IsForStudent))
    }
    const url = `${TEACHER_EVALUATIONS_CRITERIAS_REPORT}?${queryParams.toString()}`;
    return await get<TeacherEvaluationReportType>(url)
};